import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DemandasMonitoramentoService } from '../services/demandas-monitoramento.service';
import { DemandasMonitoramento } from '../models/demandas-monitoramento.model';

@Injectable({
  providedIn: 'root'
})
export class ListAndamentoDemandasResolver implements Resolve<boolean> {

  constructor(private service: DemandasMonitoramentoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.listAndamento();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ListSituacaoDemandasResolver implements Resolve<boolean> {

  constructor(private service: DemandasMonitoramentoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.listSituacao();
  }
}

@Injectable({
  providedIn: 'root'
})
export class InfoDemandaResolver implements Resolve<boolean> {

  constructor(private service: DemandasMonitoramentoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
